<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="tab">
        <div
          class="tab-item"
          :class="currTap === 'claimNewCoins' ? 'active' : ''"
          @click="onTap('claimNewCoins')"
        >
          <I18Lang id="text7" defaultText="领取风险补偿赠金" />
        </div>
        <div
          class="tab-item"
          :class="currTap === 'useNewCoins' ? 'active' : ''"
          @click="onTap('useNewCoins')"
        >
          <I18Lang id="text8" defaultText="使用风险补偿赠金" />
        </div>
      </div>

      <div v-if="currTap === 'claimNewCoins'">
        <div class="header-panel">
          <div class="statistics">
            <div class="statistic-item">
              <div class="label"><I18Lang id="text9" defaultText="总赠金" /></div>
              <div class="num">{{ giftInfo.total_gift }}</div>
            </div>
            <div class="statistic-item">
              <div class="label"><I18Lang id="text10" defaultText="当前赠金余额" /></div>
              <div class="num">{{ giftInfo.gift_balance }}</div>
            </div>
            <div class="statistic-item">
              <div class="label"><I18Lang id="text11" defaultText="待领取赠金" /></div>
              <div class="num">{{ giftInfo.gift_pool }}</div>
            </div>
          </div>

          <div class="receive-gift">
            <div class="btn kg-btn2" @click="receiveGift">
              <I18Lang id="text12" defaultText="手动领取赠金" />
            </div>
            <div class="auto-receive-gift">
              <el-switch v-model="status" @change="setAutoReceive" />
              <div class="text">
                <I18Lang id="text13" defaultText="自动领取赠金" />
              </div>
            </div>
          </div>
          <div class="btn-rule" @click="dialogVisible = true"></div>
        </div>

        <div class="reset-table table">
          <el-table :data="tableGiftData.list" style="width: 100%">
            <el-table-column width="200" label="流水号" prop="stream_no">
              <template slot="header">
                <I18Lang id="text14" defaultText="流水号" />
             </template>
            </el-table-column>
            <el-table-column label="总资产" prop="total_asset">
              <template slot="header">
                <I18Lang id="text15" defaultText="总资产" />
             </template>
            </el-table-column>
            <el-table-column label="领取比例" prop="settle_rate">
              <template slot="header">
                <I18Lang id="text17" defaultText="领取比例" />
              </template>
            </el-table-column>
            <el-table-column label="赠金金额" prop="gift_amount">
              <template slot="header">
                <I18Lang id="text16" defaultText="赠金金额" />
              </template>
            </el-table-column>
            <el-table-column label="当前赠金余额" prop="gift_balance">
              <template slot="header">
                <I18Lang id="text18" defaultText="当前赠金余额" />
              </template>
            </el-table-column>
            <el-table-column label="发放时间" prop="create_time">
              <template slot="header">
                <I18Lang id="text19" defaultText="发放时间" />
              </template>
            </el-table-column>
            <el-table-column width="200" label="领取时间" prop="receive_time">
              <template slot="header">
                <I18Lang id="text20" defaultText="领取时间" />
              </template>
              <template slot-scope="scope">
                {{ scope.row.receive_time || '-' }}
              </template>
            </el-table-column>

             <el-table-column
              width="150"
              label="赠金类型"
              prop="receive_type"
            >
              <template slot="header">
                <I18Lang id="text95" defaultText="赠金类型" />
              </template>
              <template slot-scope="scope">
                {{ giftTypeList[scope.row.gift_type] }}
              </template>
            </el-table-column>

            <el-table-column
              width="150"
              label="赠金领取方式"
              prop="receive_type"
            >
              <template slot="header">
                <I18Lang id="text21" defaultText="赠金领取方式" />
              </template>
              <template slot-scope="scope">
                {{ statusList[scope.row.receive_type] }}
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @current-change="pageGiftChange"
              layout="prev, pager, next"
              :total="tableGiftData.total"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="header-panel">
          <div class="statistics">
            <div class="statistic-item">
              <div class="label">
                <I18Lang id="text22" defaultText="已使用赠金" />
              </div>
              <div class="num">{{ giftInfo.used_gift }}</div>
            </div>

            <div class="statistic-item">
              <div class="label">
                <I18Lang id="text23" defaultText="可抵扣赠金" />
              </div>
              <div class="num">{{ giftInfo.trade_loss }}</div>
            </div>
          </div>
          <div class="btn kg-btn2" @click="giftUsed">
            <I18Lang id="text24" defaultText="使用赠金" />
          </div>
        </div>

        <div class="reset-table table">
          <el-table :data="tableGiftUsedData.list" style="width: 100%">
            <el-table-column width="200" label="流水号" prop="id">
              <template slot="header">
                <I18Lang id="text25" defaultText="流水号" />
             </template>
            </el-table-column>
            <el-table-column label="抵扣赠金金额" prop="deduct_gift">
              <template slot="header">
                <I18Lang id="text26" defaultText="抵扣赠金金额" />
              </template>
            </el-table-column>
            <el-table-column label="" prop="gift_balance">
              <template slot="header">
                <I18Lang id="text27" defaultText="当前赠金余额" />
              </template>
            </el-table-column>
            <el-table-column label="当前现金账户余额" prop="cash_balance">
              <template slot="header">
                <I18Lang id="text28" defaultText="当前现金账户余额" />
              </template>
            </el-table-column>
            <el-table-column label="生成时间" prop="create_time">
              <template slot="header">
                <I18Lang id="text29" defaultText="生成时间" />
              </template>
            </el-table-column>
            <el-table-column label="使用时间" prop="used_time">
              <template slot="header">
                <I18Lang id="text30" defaultText="使用时间" />
              </template>
              <template slot-scope="scope">
                {{ scope.row.used_time}}
              </template>
            </el-table-column>
            <el-table-column label="说明" prop="status">
              <template slot="header">
                <I18Lang id="text31" defaultText="说明" />
              </template>
              <template slot-scope="scope">
                {{ statusOptions[scope.row.status] }}
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @current-change="pageGiftUsedChange"
              layout="prev, pager, next"
              :total="tableGiftUsedData.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="info-dialog"
    >
      <template slot="title">
        <I18Lang
          id="text319"
          defaultText="风险补偿赠金规则（MEQ-A）"
          style="color:#fff;font-size: 18px;"
        />
      </template>
      <div class="dialog-content">
        <div class="title">
          <I18Lang id="text320" defaultText="一、定义" />
        </div>
        <p>
          <I18Lang
            id="text133"
            defaultText="风险补偿赠金（Active Meta Equity，简称“MEQ-A”）系已完成激活的权益额度，仅用于在特定条件下抵扣交易亏损，不构成用户可自由支配资金。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text321" defaultText="二、获取方式" />
        </div>
        <p>
          <I18Lang
            id="text134"
            defaultText="用户可通过以下方式获得MEQ-A："
          />
        </p>
        <p>
          <I18Lang
            id="text135"
            defaultText="1.待激活元股转化。"
          />
        </p>
        <p>
          <I18Lang
            id="text136"
            defaultText="2.账户余额奖励。平台可根据用户账户总资产及相关规则，按日计算并发放一定比例的MEQ-A。 公式为："
          />
        </p>
        <p class="formula">
          <I18Lang
            id="text137"
            defaultText="MEQ-A=账户总资产*奖励比例"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text322" defaultText="三、使用规则" />
        </div>
        <p>
          <I18Lang
            id="text139"
            defaultText="1.MEQ-A仅可用于抵扣用户在平台交易过程中产生的亏损。"
          />
        </p>
        <p>
          <I18Lang
            id="text140"
            defaultText="2.MEQ-A仅在发生亏损时按系统规则自动使用，不支持手动操作。"
          />
        </p>
        <p>
          <I18Lang
            id="text141"
            defaultText="3.MEQ-A不得用于开仓、加仓或作为保证金使用。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text323" defaultText="四、使用限制" />
        </div>
        <p>
          <I18Lang
            id="text142"
            defaultText="MEQ-A属于赠金性质权益，明确不具备资金属性，并受以下限制："
          />
        </p>
        <p>
          <I18Lang
            id="text143"
            defaultText="1.不得提现、转让或变现；"
          />
        </p>
        <p>
          <I18Lang
            id="text144"
            defaultText="2.不得用于交易本金或参与收益分配；"
          />
        </p>
        <p>
          <I18Lang
            id="text145"
            defaultText="3.不构成用户资产或平台负债；"
          />
        </p>
        <p>
          <I18Lang
            id="text146"
            defaultText="4.不产生利息或任何形式收益；"
          />
        </p>
        <p>
          <I18Lang
            id="text147"
            defaultText="5.不构成平台对用户收益或本金安全的承诺。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text324" defaultText="五、风险提示" />
        </div>
        <p>
          <I18Lang
            id="text148"
            defaultText="1.用户理解并同意，平台提供的MEQ-A仅作为风险缓冲工具，不代表任何收益保障。"
          />
        </p>
        <p>
          <I18Lang
            id="text149"
            defaultText="2.所有交易行为均存在风险，用户应独立判断并自行承担交易损失。"
          />
        </p>
        <p>
          <I18Lang
            id="text150"
            defaultText="3.平台不对用户因交易产生的任何损失承担赔偿责任（法律另有规定的除外）。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text325" defaultText="六、风控与违规处理" />
        </div>
        <p>
          <I18Lang
            id="text151"
            defaultText="1.如平台发现用户存在套利、刷赠金、对冲交易或其他异常行为，有权："
          />
        </p>
        <p>
          <I18Lang
            id="text152"
            defaultText="1）.冻结或收回MEQ-A；"
          />
        </p>
        <p>
          <I18Lang
            id="text153"
            defaultText="2）.取消用户参与资格；"
          />
        </p>
        <p>
          <I18Lang
            id="text154"
            defaultText="3）.追究相关责任。"
          />
        </p>
        <p>
          <I18Lang
            id="text155"
            defaultText="2.平台有权对异常账户进行审查，并采取必要的限制措施。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text326" defaultText="七、规则调整与最终解释权" />
        </div>
        <p>
          <I18Lang
            id="text156"
            defaultText="1.平台有权根据业务需要对MEQ-A的获取方式、使用规则及相关条款进行调整。"
          />
        </p>
        <p>
          <I18Lang
            id="text157"
            defaultText="2.相关调整将以公告形式发布，并自公告之日起生效。"
          />
        </p>
        <p>
          <I18Lang
            id="text158"
            defaultText="3.在法律允许范围内，本规则的最终解释权归平台所有。"
          />
        </p>

        <div class="btn kg-btn2" @click="dialogVisible = false">
          <I18Lang id="my98" defaultText="Close" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      dialogVisible: false,
      currTap: 'claimNewCoins',
      queryGiftForm: {
        page: '',
        size: ''
      },
      statusOptions: {
        0: i18n.t('text41'),
        1: i18n.t('text42')
      },
      queryGiftUsedForm: {
        page: '',
        size: ''
      },
      tableGiftData: {
        list: [],
        total: 0
      },
      tableGiftUsedData: {
        list: [],
        total: 0
      },
      status: 1,
      giftTypeList: {
        1: i18n.t('text96'),
        2: i18n.t('text97')
      },
      statusList: {
        1: i18n.t('text43'),
        2: i18n.t('text44')
      },
      giftInfo: {}
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    this.getGiftInfo()
    this.getGiftRecord()
    this.getGiftUsedRecord()
  },
  methods: {
    getGiftInfo () {
      this.$http.post('/api/gift/info').then((result) => {
        this.giftInfo = result
        this.status = Boolean(result.receive_auto)
      })
    },
    onTap (type) {
      this.currTap = type
      if (type === 'claimNewCoins') {
        this.getGiftRecord()
      } else {
        this.getGiftUsedRecord()
      }
    },
    pageGiftChange (page) {
      this.queryGiftForm.page = page
      this.getGiftRecord()
    },
    getGiftRecord () {
      this.$http
        .post('/api/gift/records', this.queryGiftForm)
        .then((result) => {
          this.tableGiftData = result
        })
    },
    pageGiftUsedChange (page) {
      this.queryGiftUsedForm.page = page
      this.getGiftUsedRecord()
    },
    getGiftUsedRecord () {
      this.$http
        .post('/api/gift/usedRecords', this.queryGiftUsedForm)
        .then((result) => {
          this.tableGiftUsedData = result
        })
    },
    setAutoReceive () {
      // 1：开启，0：关闭
      this.$http
        .post('/api/gift/setAutoReceive', { status: +this.status })
        .then((result) => {})
    },
    receiveGift () {
      this.$http.post('/api/gift/receiveGift').then((result) => {
        this.$alert('Claim Successful', {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: (action) => {
            this.getGiftInfo()
          }
        })
      }).finally(() => {
        this.getGiftRecord()
        this.getGiftInfo()
      })
    },
    giftUsed () {
      this.$http.post('/api/gift/use').then((result) => {
        this.$alert('Successful', {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: (action) => {
            this.getGiftInfo()
          }
        })
      }).finally(() => {
        this.getGiftUsedRecord()
        this.getGiftInfo()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.app-page {
  .tab {
    display: flex;
    margin-top: 17px;

    .tab-item {
      width: 186px;
      height: 42px;
      line-height: 42px;
      background: url("../../../assets/img/bonus/tab.png") no-repeat center /
        100% 100%;
      color: #fff;
      font-size: 16px;
      text-align: center;
      cursor: pointer;

      &:first-child {
        margin-right: 19px;
      }

      &.active {
        background: url("../../../assets/img/bonus/tab-active.png") no-repeat
          center / 100% 100%;
      }
    }
  }

  .header-panel {
    display: flex;
    align-items: center;

    .statistics {
      display: flex;
      margin: 20px 0;

      .statistic-item {
        width: 330px;
        height: 69px;
        background: url("../../../assets/img/bonus/statistics-item-bg.png")
          no-repeat center / 100% 100%;
        margin-right: 20px;

        .label {
          text-align: center;
          color: #fff;
          font-size: 16px;
          line-height: 16px;
          margin-top: 10px;
        }

        .num {
          text-align: center;
          font-size: 26px;
          line-height: 26px;
          margin-top: 10px;
          color: #00cbfa;
        }
      }
    }

    .receive-gift {
      .btn {
        width: 120px;
        height: 55px;
        line-height: 58px;
      overflow: hidden;
      }

      .auto-receive-gift {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #fff;

        .text {
          margin-left: 4px;
        }
      }
    }

    .btn-rule {
      color: #fff;
      margin-top: -18px;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      min-width: 45px;
      text-shadow: 2px 2px 10px #00cffb;
      text-align: center;
      background: url("../../../assets/img/btn/bt3down.png") no-repeat center /
        100% 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &::before {
        content: "";
        width: 22px;
        height: 22px;
        display: block;
        background: url("../../../assets/img/bonus/btn-rule.png") no-repeat
          center / 100% 100%;
      }

      &:hover {
        background: url("../../../assets/img/btn/bt3hov.png") no-repeat center /
          100% 100%;
      }

      &.btn-query-refresh {
        height: 42px;
      }
    }
  }
}

::v-deep .info-dialog {
  .el-dialog {
    width: min(720px, calc(100vw - 32px)) !important;
    margin-top: 8vh !important;
    border-radius: 18px;
    overflow: hidden;
    background: url("../../../assets/img/dialog-bg/bg2.png") no-repeat center /
      100% 100%;
    box-shadow: 0 20px 48px rgba(0, 17, 42, 0.45);
  }

  .el-dialog__header {
    padding: 24px 28px 0;
  }

  .el-dialog__title {
    display: block;
    padding-right: 24px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    color: #fff;
    text-shadow: 0 4px 16px rgba(0, 207, 251, 0.35);
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;

    .el-dialog__close {
      color: rgba(255, 255, 255, 0.78);
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 40px 28px 28px;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
}

.dialog-content {
  color: #fff;

  .title {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.5;
    color: #01c8ff;

    &:first-child {
      margin-top: 4px;
    }

    &.t2 {
      margin-top: 10px;
    }
  }

  p {
    margin: 10px 0 0;
    font-size: 14px;
    line-height: 26px;
    color: rgba(255, 255, 255, 0.92);
    word-break: break-word;
  }

  .formula {
    margin-top: 12px;
    padding: 10px 14px;
    border-left: 3px solid #01c8ff;
    border-radius: 10px;
    background: rgba(1, 178, 245, 0.08);
    color: #d7f7ff;
  }

  .btn {
    width: 168px;
    margin: 24px auto 0;
    display: block;
    text-align: center;
    line-height: 46px;
  }
}

@media (max-width: 768px) {
  ::v-deep .info-dialog {
    .el-dialog {
      margin-top: 4vh !important;
    }

    .el-dialog__header {
      padding: 20px 20px 0;
    }

    .el-dialog__title {
      font-size: 18px;
    }

    .el-dialog__body {
      padding: 22px 20px 24px;
      max-height: calc(100vh - 120px);
    }
  }

  .dialog-content {
    .title {
      font-size: 16px;
    }

    p {
      line-height: 24px;
    }

    .btn {
      width: 150px;
    }
  }
}
</style>
